export default __webpack_public_path__ + "7c344a5ca8719b9cb7ba1f1f0848def3.woff";